<!-- No back button: the visitor arrived here from a link in a chat app, so
     there is nothing behind this page to go back to. -->
<cs-header [backButton]="false">
  <cs-header-title>{{ LL.referral.invite.headerTitle() }}</cs-header-title>
</cs-header>

<cs-content>
  <div class="invite-content">
    @switch (state) {
      @case (ReferralInviteState.Checking) {
        <div class="invite-checking">{{ LL.referral.invite.checking() }}</div>
      }

      @case (ReferralInviteState.Valid) {
        <cs-icon name="people"></cs-icon>
        <div class="invite-title">{{ LL.referral.invite.title({ name: inviterFirstName }) }}</div>
        <div class="invite-subtitle">{{ LL.referral.invite.subtitle() }}</div>
        <!-- Said BEFORE the button, not after it (#4963 phase 3). This is the one
             page a friend sees before accepting, and the same line appears on the
             two code boxes that bypass it. -->
        <div class="invite-disclosure" id="referral-invite-disclosure">{{ LL.referral.disclosure() }}</div>
        <cs-button primary medium id="referral-invite-start-button" (click)="onPrimaryButtonClick($event)"
          [label]="isAlreadySignedIn ? LL.referral.invite.continueButton() : LL.referral.invite.startButton()"></cs-button>
      }

      @case (ReferralInviteState.Invalid) {
        <div class="invite-title">{{ LL.referral.invite.invalidTitle() }}</div>
        <div class="invite-subtitle">{{ LL.referral.invite.invalidSubtitle() }}</div>
        <cs-button secondary medium id="referral-invite-fallback-button" (click)="onPrimaryButtonClick($event)"
          [label]="isAlreadySignedIn ? LL.referral.invite.continueButton() : LL.referral.invite.invalidButton()"></cs-button>
      }
    }
  </div>
</cs-content>
